import admin_billing from './admin_billing'
import admin_color from './admin_color'
import admin_comment from './admin_comment'
import admin_floorplan from './admin_floorplan'
import admin_lane from './admin_lane'
import admin_membership from './admin_membership'
import admin_route from './admin_route'
import admin_sector from './admin_sector'
import admin_settings from './admin_settings'
import admin_spot from './admin_spot'
import admin_stats from './admin_stats'
import common from './common'
import component_scales from './component_scales'
import component_user_selector from './component_user_selector'
import error from './error'
import page_authentication from './page_authentication'
import page_comment from './page_comment'
import page_landing from './page_landing'
import page_profile from './page_profile'
import page_route from './page_route'
import page_spot from './page_spot'
import page_workout from './page_workout'
import page_workout_log from './page_workout_log'

export default {
  translation: {
    intlNumber: '{{value, number}}',
    intlCurrency: '{{value, currency(currency: EUR)}}',

    common,
    error,

    admin: {
      route: admin_route,
      comment: admin_comment,
      stats: admin_stats,
      floorPlan: admin_floorplan,

      settings: admin_settings,
      color: admin_color,
      sector: admin_sector,
      spot: admin_spot,
      lane: admin_lane,
      membership: admin_membership,

      billing: admin_billing,
    },

    component: {
      scales: component_scales,
      user_selector: component_user_selector,
    },

    page: {
      profile: page_profile,
      landing: page_landing,
      authentication: page_authentication,
      spot: page_spot,

      comment: page_comment,
      route: page_route,
      workout: page_workout,
      workoutLog: page_workout_log,
    },
  },
}
